import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Button } from '@mui/material';

/**
 * PWA Update Notification Component
 * Notifies users when a new version is available
 */
export const PWAUpdateNotification: React.FC = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return;
    }

    navigator.serviceWorker.ready.then((registration) => {
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New service worker available
            setWaitingWorker(newWorker);
            setShowUpdate(true);
          }
        });
      });
    });

    // Listen for controlling service worker change
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });
  }, []);

  const handleUpdate = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      setShowUpdate(false);
    }
  };

  const handleClose = () => {
    setShowUpdate(false);
  };

  return (
    <Snackbar
      open={showUpdate}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={handleClose}
    >
      <Alert
        severity="info"
        action={
          <Button color="inherit" size="small" onClick={handleUpdate}>
            Update
          </Button>
        }
        onClose={handleClose}
        sx={{ width: '100%' }}
      >
        A new version is available! Click Update to refresh.
      </Alert>
    </Snackbar>
  );
};
